// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__27X-8","sendOtp":"AuthorizeToLogin_sendOtp__1VGpf"};